export default __webpack_public_path__ + "ef32176b4a2de334b6d420134f1ce093.jpg";